import {combineReducers} from 'redux';
import calculator from './calculator';
import scrolling from './scrolling';

export const educationCalculator = combineReducers({
    calculator,
    scrolling
});
